





import { Component, Vue, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";
import qNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import RepairContent from "@/model/repairContent";
import QCalendar from "@/common/qCalendar.vue";
import QUserSelect from "@/common/qUserSelect.vue";
import QWitnessSelect from "@/common/qWitnessSelect.vue";
import QMasterDirectionSelect from "@/common/qMasterDirectionSelect.vue";
import QFaceSelect from "@/common/qFaceSelect.vue";
import QMaterialSelect from "@/common/qMaterialSelect.vue";
import QRepairDetailSelect from "@/common/qRepairDetailSelect.vue";
import QFloorAreaSelect from "@/common/qFloorAreaSelect.vue";
import QPolygonFloor, { drawMode } from "@/common/qPolygonFloor.vue";
import FloorArea from "@/model/floorArea";
import fileApi from "@/api/fileApi";
import VueUploadComponent from "vue-upload-component";
import repairContentApi from "@/api/repairContentApi";
import floorApi from "@/api/floorApi";
import FloorPlan from "@/model/floor";
import Company from "@/model/company";
import { namespace } from "vuex-class";
import _ from "lodash";
import {compareWithKeys} from "@/common/utils";
import propertyApi from "@/api/propertyApi";
const auth = namespace("Auth");
@Component({
  name: "RepairContentUpdateComponent",
  components: {
    draggable,
    QErrors,
    QCalendar,
    QUserSelect,
    QWitnessSelect,
    QMasterDirectionSelect,
    QFaceSelect,
    QMaterialSelect,
    QRepairDetailSelect,
    QFloorAreaSelect,
    QPolygonFloor,
    VueUploadComponent,
  },
})
export default class RepairContentUpdateComponent extends Vue {
  @auth.Getter
  getCurrentyCompany!: Company;

  mounted() {
    // this.getRepair();
  }
  files = [];
  public isShow = false;
  public repairContent = new RepairContent();
  public repairContentInit = new RepairContent();
  public floorPlan = new FloorPlan();
  public errors = {};
  public dateConfig = {};
  public beforeUploadClass = [];
  public afterUploadClass = [];
  public imageSelected = 0;
  public mod = "new";

  get companyId() {
    return this.getCurrentyCompany.id;
  }
  /**
   * getRepair
   */
  public async getRepair(id) {
    this.repairContent = await repairContentApi.show(id);
    this.repairContentInit = _.cloneDeep(this.repairContent)
  }

  public async getFloor(id) {
    this.floorPlan = await floorApi.detail(id);
  }

  get isEdit() {
    return this.repairContent.id !== null || this.repairContent._id;
  }
  public inputFile(newFile, type) {
    this.handleFileUpload(
      newFile.map((item) => item.file),
      type
    );
    this.files = [];
  }

  public inputFilter(newFile, oldFile, prevent) {
    if (newFile && !oldFile && !/\.(jpeg|jpg|png)$/i.test(newFile.name)) {
      return prevent();
    }
  }

  public close() {
    this.isShow = true;
  }

  public async showById(repair: RepairContent, mode) {
    // this.getRepair(id);
    this.isShow = true;
    const request = [
      await repairContentApi.show(repair.id),
      await floorApi.detail(repair.floor_plan.id),
      await propertyApi.show(repair.property_id),
    ];

    const result = await Promise.all(request);

    this.mod = mode;

    this.repairContent = result[0];
    this.repairContent.floor_plan = result[1];
    this.repairContent.property = result[2];
    this.$nextTick().then(() => {
      (this.$refs.floorEditor as QPolygonFloor).loadObject(
        this.repairContent.floor_plan.svg_object,
        this.repairContent.floor_plan.areas,
        drawMode.repair
      );
      this.changeArea();
    });
    this.repairContentInit = _.cloneDeep(this.repairContent)
  }
  /**
   * show
   */
  public show(repair: RepairContent = null, mode = "edit", repairContentTemporary: RepairContent[] = [], isClone = false) {
    this.isShow = true;
    this.errors = {};
    this.mod = mode;

    this.repairContent = repair;
    this.repairContent.repairContentTemporary = repairContentTemporary;
    this.$nextTick().then(() => {
      this.$refs.floorEditor && (this.$refs.floorEditor as QPolygonFloor).loadObject(
        this.repairContent.floor_plan.svg_object,
        this.repairContent.floor_plan.areas,
        drawMode.repair
      );
      this.changeArea();
    });
    if (isClone) {
      this.repairContent.calcRemainDay();
    }
    this.repairContentInit = _.cloneDeep(this.repairContent)
  }

  public hide() {
    this.$modal.showCancel({
      text: this.$t("cancel"),
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.isShow = false;
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public onSelectArea(groupId) {
    if (!groupId) {
      return;
    }

    const area = this.repairContent.floor_plan.areas.find(
      (item: FloorArea) => item.group_id === groupId
    );
    this.repairContent.floor_plan_area_id = area.id;
    this.repairContent.floor_plan_area = area;
  }

  public changeArea() {
    const area = this.repairContent.floor_plan.areas.find(
      (item: FloorArea) => item.id === this.repairContent.floor_plan_area_id
    );
    if (area) {
      this.repairContent.floor_plan_area = area;
      (this.$refs.floorEditor as QPolygonFloor).selectAreaRepair(area.group_id, this.repairContent.svg_position || null);
    } else {
      (this.$refs.floorEditor as QPolygonFloor).selectAreaRepair(null);
    }
  }

  public removeImage(type, index) {
    this.repairContent[type].splice(index, 1);
  }

  public async handleFileUpload(files, fileOf = "before_repair") {
    if (files.length === 0) {
      return;
    }
    const requestUploads = [];
    for (const file of files) {
      let formData = new FormData();
      formData.append("image", file);
      formData.append("image_type", "RepairContent");
      requestUploads.push(fileApi.uploadImage(formData));
    }
    const results = await Promise.all(requestUploads);

    for (const result of results) {
      if (result.meta.status === 200) {
        this.repairContent[fileOf].push(result.data);
      }
    }
  }

  public onChangeFile(reference, type) {
    this.handleFileUpload((this.$refs[reference] as any).files, type);
  }

  public mainImage(type) {
    if (
      this.repairContent[type].length > 0 &&
      this.repairContent[type][this.imageSelected]
    ) {
      return this.repairContent[type][this.imageSelected].url;
    } else {
      return this.repairContent[type][this.repairContent[type].length - 1].url;
    }
  }

  public cancel() {
    if (this.isChangedProperty()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.errors = {};
          this.isShow = false;
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.errors = {};
      this.isShow = false;
    }
  }

  public async uploadImageSVG(file) {
    let formData = new FormData();
    formData.append("image", file);
    formData.append("image_type", "RepairContent");
    const result = await fileApi.uploadImage(formData);
    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t(result.meta.message),
      });
    } else {
      this.repairContent.repair_image_id = result.data.id;
    }
  }

  public async submit() {
    this.errors = {};
    const objectSVG = (this.$refs.floorEditor as QPolygonFloor).export();
    const repairIcon = (this.$refs.floorEditor as QPolygonFloor).getRepaiIconPosition();

    this.repairContent.svg_position = repairIcon;
    await this.uploadImageSVG(objectSVG.file);

    const result = await this.repairContent.save();
    if (result.meta.status === 200) {
      if (this.mod === "exists-property") {
        if (this.repairContent.id) {
          qNotify.success({
            text: this.$t("repairContents.updated"),
          });
          // this.repairContent.id = result
          this.$emit("update", this.repairContent);
        } else {
          qNotify.success({
            text: this.$t("repairContents.created"),
          });
          this.repairContent.id = result.data.id;
          this.$emit("add", this.repairContent);
        }
      } else {
        if (this.repairContent._id || this.repairContent.id) {
          this.$emit("update", this.repairContent);
        } else {
          this.repairContent.id = result.data.id;
          this.$emit("add", this.repairContent);
        }
      }
      this.isShow = false;
      this.errors = {};
      this.$emit("change");
    } else {
      this.errors = result.meta.errors;
      qNotify.error({
        text: this.$t('repairContents.can_not_create'),
      });
    }
  }

  public async remove() {
    this.$modal.showDelete({
      text: "削除を実行します。この操作は取り消せません。",
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        if (this.repairContent._id) {
          this.$emit("removeTmp", this.repairContent._id);
        } else {
          const result = await this.repairContent.remove();
          if (result.meta.status === 200) {
            qNotify.success({
              text: this.$t("repairContents.deleted"),
            });
            this.$emit("removeTmp", this.repairContent.id);
          } else {
            qNotify.error({
              text: result.meta.message,
            });
          }
        }
        this.isShow = false;
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  @Watch('isShow')
  public checkDisplayModal() {
    if (this.isShow) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = 'auto';
    }
  }

  public isChangedProperty() {
    if (this.repairContent.before_repair.length !== this.repairContentInit.before_repair.length) {
      return true;
    }
    if (this.repairContent.after_repair.length !== this.repairContentInit.after_repair.length) {
      return true;
    }

    return compareWithKeys(this.repairContent, this.repairContentInit, [
      'repair_date',
      'property_id',
      'witness_id',
      'person_in_charge_id',
      'floor_plan_area_id',
      'direction_id',
      'face_id',
      'material_id',
      'repair_detail_id',
      'number_of_depreciation',
      'remarks',
    ])
  }
}
